import ApiSubscription from '../_subbase';
import cookie from 'react-cookies';

class MgmApi {
	async loginMgm() {
		// const response = await auth.getLogin(email, pass);
		try {
			const response = await ApiSubscription.post('/token', {
				email: process.env.REACT_APP_ECOMMERCE_USER,
				password: process.env.REACT_APP_ECOMMERCE_PSW
			});
			cookie.save('SubToken', response.data.token);
		} catch (err) {
			console.log(err);
		}
	}

	async indication(data) {
		const response = await ApiSubscription.post('/campaigns/mgm', data, true);

		return {
			data: response.data,
			status: response.status,
			statusText: response.statusText
		};
	}
}

export default new MgmApi();
